//import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
// import * as L from 'leaflet';
//import { StoreFinderService } from 'src/app/services/feature/store-finder/store-finder.service';


/* import { Icon, Marker } from 'leaflet'
declare let L;
let map;
@Component({
    selector: 'app-kb-store-finder',
    templateUrl: './kb-store-finder.component.html',
    styleUrls: ['./kb-store-finder.component.scss'],
    standalone: false
})
export class KbStoreFinderComponent {
  storeSearchText:string;
  storeDetails$:any;
  currentPage:any=0;
  showMapData:boolean=false;
  noRecordsFound:boolean;
  pinLengthCheck:boolean = false;
  onlyDigitNumber:boolean = false;
  private defaultIcon: Icon = L.icon({
    iconSize: [ 25, 41 ],
    iconAnchor: [ 13, 0 ],
    // specify the path here
 });
 
 @ViewChild('scroller1') scroller: ElementRef;
  constructor(private storeFinderService:StoreFinderService,
    private cdr: ChangeDetectorRef){

  }

  private map;

  private initMap(fromPagination?): void {
    this.storeDetails$.subscribe(data=>{
      this.noRecordsFound = false;
      if(data.stores.length>0){
        this.showMapData = true;
        if(fromPagination){
          this.selectStore(data.stores[0].geoPoint.latitude, data.stores[0].geoPoint.longitude);
        }else{
        Marker.prototype.options.icon = this.defaultIcon;
        this.map = L.map('map').setView([data.stores[0].geoPoint.latitude, data.stores[0].geoPoint.longitude], 13);
       
        const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          maxZoom: 13,
          attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        });
    
        tiles.addTo(this.map);
        let marker;
        for (let i = 0; i < data.stores.length; i++) {
            marker = new L.marker( [data.stores[i].geoPoint.latitude, data.stores[i].geoPoint.longitude])
              .bindPopup('<span class="color-blue">'
                  + data.stores[i].address.companyName 
                  + '</span> <br/>' 
                  +data.stores[i].address.line1
                  + '<br/>' 
                  + data.stores[i].address.town + ' ' + data.stores[i].address.postalCode
                  + '<br/>' 
                  + data.stores[i].address.region.name
                  )
            marker.addTo(this.map)
        }
      }
      
      }else{
        this.noRecordsFound = true;
        this.showMapData = false;
      }
    })
  }

  searchStore(fromPagination?){
    if(this.storeSearchText){
      this.storeFinderService.getLatLong(this.storeSearchText).subscribe((data:any)=>{
        this.storeDetails$ = this.storeFinderService.getStoreDetails(this.storeSearchText,data[0].lat, data[0].lon, this.currentPage);
        this.showMapData=true;
        this.initMap(fromPagination);
        this.cdr.detectChanges();
      })
    }else{
      this.noRecordsFound = true;
      this.showMapData=false;
    }
  }

  prev(){
    this.currentPage-=1;    
    this.searchStore(true); 
  }

  next(){
    this.currentPage+=1;
    this.searchStore(true);   
  }

  selectStore(lat, long){			
      const coords = [lat, long]
      this.map.flyTo(coords, 13);
  }

  validate(e){
    this.pinLengthCheck = false;
    this.onlyDigitNumber = false;
    const inputValue=e.target.value.trim();
    const regDigit = /^[0-9 ]*$/;
    const regCharc=/^[A-Za-z ]*$/;
    if(inputValue.length!=0){
    	
       if(inputValue.match(regDigit)){
         if(inputValue.length!=5){
        this.pinLengthCheck=true;
        }
      }
        else if((inputValue.match(regCharc))){
            this.onlyDigitNumber = false;
          this.pinLengthCheck = false;
         }
         else {
              const inputvaluespace=inputValue.charAt(3);
              const spaceCount=inputValue.split(" ").length-1;
                 if((inputValue.length === 7)&&(inputvaluespace === " ")&&(spaceCount === 1)){	
              }
              else{
               this.onlyDigitNumber = true;
              }					      
          }
                 
      }
  }
}
 */
import {
  Component,
  ElementRef,
  ViewChild,
  ChangeDetectorRef,
  Inject,
  PLATFORM_ID,
  OnInit,
  AfterViewInit
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { StoreFinderService } from '../../../services/feature/store-finder/store-finder.service' // adjust path as needed
import { shareReplay, take } from 'rxjs';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-kb-store-finder',
  templateUrl: './kb-store-finder.component.html',
  styleUrls: ['./kb-store-finder.component.scss'],
  standalone: false
})
export class KbStoreFinderComponent implements AfterViewInit {
  storeSearchText: string;
  storeDetails$: any;
  currentPage: any = 0;
  showMapData: boolean = false;
  noRecordsFound: boolean;
  pinLengthCheck: boolean = false;
  onlyDigitNumber: boolean = false;
  map: any;
  leaflet: any;
  defaultIcon: any;

  @ViewChild('scroller1') scroller: ElementRef;
  subscription = new Subscription();
  constructor(
    private storeFinderService: StoreFinderService,
    private cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  async ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      const L = (await import('leaflet')).default;   // ✅ FIX HERE
      this.leaflet = L;
      this.defaultIcon = L.icon({
        iconSize: [25, 41],
        iconAnchor: [13, 0],
        iconUrl: '/images/marker-icon.png',
        shadowUrl: '/images/marker-shadow.png'
      });
    }
  }

  private initMap(fromPagination?): void {
    if (!isPlatformBrowser(this.platformId) || !this.leaflet) {
      return;
    }


    this.storeDetails$
      .pipe(take(1)).subscribe(data => {
        this.noRecordsFound = false;
        if (data.stores.length > 0) {
          this.showMapData = true;
          const L = this.leaflet;

          if (fromPagination) {
            this.selectStore(data.stores[0].geoPoint.latitude, data.stores[0].geoPoint.longitude);
          } else {
            L.Marker.prototype.options.icon = this.defaultIcon;
            this.map = L.map('map').setView(
              [data.stores[0].geoPoint.latitude, data.stores[0].geoPoint.longitude],
              13
            );

            const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
              maxZoom: 13,
              attribution: '&copy; http://www.openstreetmap.org/copyright'
            });

            tiles.addTo(this.map);

            for (const store of data.stores) {
              const marker = new L.marker([store.geoPoint.latitude, store.geoPoint.longitude])
                .bindPopup(
                  `<span class="color-blue">${store.address.companyName}</span><br/>
                 ${store.address.line1}<br/>
                 ${store.address.town} ${store.address.postalCode}<br/>
                 ${store.address.region.name}`
                );
              marker.addTo(this.map);
            }
          }
        } else {
          this.noRecordsFound = true;
          this.showMapData = false;
        }
      });
  }

  searchStore(fromPagination?) {
    if (this.storeSearchText) {
      this.subscription.add(this.storeFinderService.getLatLong(this.storeSearchText).subscribe((data: any) => {
        this.storeDetails$ = this.storeFinderService.getStoreDetails(this.storeSearchText, data[0].lat, data[0].lon, this.currentPage).pipe(shareReplay(1));
        this.showMapData = true;
        this.initMap(fromPagination);
        this.cdr.detectChanges();
      }));
    } else {
      this.noRecordsFound = true;
      this.showMapData = false;
    }

  }

  prev() {
    this.currentPage -= 1;
    this.searchStore(true);
  }

  next() {
    this.currentPage += 1;
    this.searchStore(true);
  }

  selectStore(lat, long) {
    if (this.map) {
      const coords = [lat, long];
      this.map.flyTo(coords, 13);
    }
  }

  validate(e) {
    this.pinLengthCheck = false;
    this.onlyDigitNumber = false;
    const inputValue = e.target.value.trim();
    const regDigit = /^[0-9 ]*$/;
    const regCharc = /^[A-Za-z ]*$/;

    if (inputValue.length !== 0) {
      if (regDigit.test(inputValue)) {
        if (inputValue.length !== 5) {
          this.pinLengthCheck = true;
        }
      } else if (regCharc.test(inputValue)) {
        this.onlyDigitNumber = false;
        this.pinLengthCheck = false;
      } else {
        const inputvaluespace = inputValue.charAt(3);
        const spaceCount = inputValue.split(' ').length - 1;
        if (!(inputValue.length === 7 && inputvaluespace === ' ' && spaceCount === 1)) {
          this.onlyDigitNumber = true;
        }
      }
    }
  }
  ngOnDestroy(): void {
    // Unsubscribe from the scroll event
    if (this.subscription && this.subscription instanceof Subscription) {
      this.subscription.unsubscribe();
    }

  }
}
